<template>
	<div class="my-check-button-group" :style="{ '--num': num }">
		<div class="edit-check-box-item" :class="{ checked: list.includes(item[optionValue]), 'margin-top-zero': marginTopZero(index), disabled: disabled || item.disabled }" v-for="(item, index) in options" :key="index" @click="handleSelect(item)">
			{{ item[optionLabel] }}
			<img class="select-img" src="@/assets/images/common/icon-select.png" />
		</div>
		<slot name="more" />
	</div>
</template>

<script>
import Core from '../../core';

export default {
	name: 'MyCheckButton',
	model: {
		prop: 'value',
		event: 'update',
	},
	props: {
		value: {
			type: Array,
			default: () => {
				return [];
			},
		},
		options: {
			type: Array,
			default: () => {
				return [];
			},
		},
		optionLabel: { type: String, default: 'label' },
		optionValue: { type: String, default: 'value' },
		num: { type: Number, default: 5 },
		disabled: { type: Boolean, default: false }, // 禁止操作
		min: { type: Number, default: 0 }, // 最小选择数量
	},
	data() {
		return {
			list: [],
		};
	},
	watch: {
		value: {
			immediate: true,
			deep: true,
			handler(n) {
				this.list = n || [];
			},
		},
	},
	methods: {
		handleSelect(item) {
			if (this.disabled || item.disabled) return;
			let list = Core.Util.deepCopy(this.list);
			let value = item[this.optionValue];
			let i = list.findIndex((i) => i === value);
			if (i !== -1) {
				// 删除
				if (list.length > this.min) {
					list.splice(i, 1);
				}
			} else {
				// 添加
				list.push(value);
			}
			console.log('list:', list);
			this.$emit('update', list);
			this.$emit('change', list);
		},
		marginTopZero(i) {
			return i < this.num ? true : false;
		},
	},
};
</script>

<style lang='scss'>
.my-check-button-group {
	--disabled-color: #8f8f8f99;
	--btn-margin-horizontal: 5px;
	--btn-margin-vertical: 12px;

	display: flex;
	flex-wrap: wrap;
	position: relative;
	left: calc(-1 * var(--btn-margin-horizontal));

	.edit-check-box-item {
		width: calc((100% - (var(--btn-margin-horizontal) * 2) * var(--num)) / var(--num));
		border-radius: 6px;
		border: 1px solid #ebecf0;
		background: #fff;
		box-shadow: 0px 2px 8px -2px rgba(0, 0, 0, 0.04);
		height: 32px;
		@include fcc();
		color: #222;
		font-size: 13px;
		font-weight: 400;
		overflow: hidden;
		position: relative;
		box-sizing: border-box;
		margin: var(--btn-margin-vertical) var(--btn-margin-horizontal) 0px var(--btn-margin-horizontal);
		cursor: pointer;

		&.margin-top-zero {
			margin-top: 0px;
		}

		.select-img {
			position: absolute;
			top: -1px;
			right: -1px;
			width: 24px;
			height: 23px;
			opacity: 0;
			transition: opacity 0.1s ease;
		}

		&.active {
			border-color: $edit_panel_primary;
			color: $edit_panel_primary;
		}

		&.checked {
			border-color: $edit_panel_primary;
			color: $edit_panel_primary;
			.select-img {
				opacity: 1;
			}
		}

		&.disabled {
			cursor: not-allowed;
			background: transparent;
			border-color: #efefef;
			color: rgba(143, 143, 143, 0.6);

			&.checked {
				border-color: rgba(0, 109, 255, 0.4);
				color: rgba(0, 109, 255, 0.4);

				.select-img {
					opacity: 0.4;
				}
			}
		}
	}
}
</style>